import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

export const useUiStore = defineStore(
  'ui', 
    () => {
    // store
    const data = ref({
      breakpoint: undefined,
      orientation: undefined,
    });
    
    // actions
    function setBreakpoint(payload) {
      data.value.breakpoint = payload;
    }
    function setOrientation(payload) {
      data.value.orientation = payload;
    }

    // getters
    const breakpoint = computed(() => {
      return data.value.breakpoint
    });
    const orientation = computed(() => {
      return data.value.orientation
    });

    return { data, setBreakpoint, setOrientation, breakpoint, orientation }
  }
)
